import {Button} from "element-ui";
import vSelect from 'vue-select';
import "./element-variables.scss";
import "./vue-select-variables.scss";
import IndexFilter from "./IndexFilter";

export default {
  install(Vue) {
    Vue.component('v-select', vSelect)
    Vue.component("index-filter", IndexFilter);
    Vue.component(Button.name, Button);
  }
};
